import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";

import { KeycloakService } from "keycloak-angular";
import { first, map, switchMap, delay } from "rxjs/operators";
import { Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Store } from "@ngrx/store";
import { getProfile, selectProfile } from "../ngrx/myqq";
import { filterSuccessMapToRightValue } from "src/lib/datum-either";
import { GetProfileResponse } from "../services/myqq";

@Injectable({
  providedIn: "root",
})
export class FriendbuyGuard {
  constructor(
    readonly store$: Store,
    protected keycloak: KeycloakService,
    private router: Router
  ) {}

  canActivate(state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const loggedInValue = this.keycloak.isLoggedIn();
    if (loggedInValue) {
      this.store$.dispatch(getProfile.pending(null));
      // show /refer only when the user is not logged in or the user is logged in, has an account, and is a member
      // when user has an account but no membership, redirect to /purchase
      // when user does not have an account, redirect to home
      // show /referral-dashboard only when the user is logged in and has an account and membership
      // always show /friends page
      return this.store$.select(selectProfile).pipe(
        filterSuccessMapToRightValue,
        first(),
        map((profile: GetProfileResponse) => profile.membership),
        switchMap((membership) => {
          if (
            !!state.url.toString().startsWith("refer") &&
            !!membership &&
            !!membership.account
          ) {
            if (
              !!membership.activeCoupons &&
              membership.activeCoupons.length > 0
            ) {
              return of(true).pipe(delay(1000));
            } else {
              return of(this.router.createUrlTree(["/purchase"], {}));
            }
          } else if (!!state.url.toString().startsWith("refer")) {
            return of(this.router.createUrlTree([""], {}));
          } else {
            return of(true);
          }
        })
      );
    } else {
      return of(true);
    }
  }
}
